export const USER_PREFERENCE_KEY_LANGUAGE = 'language';
export const USER_PREFERENCE_KEY_CHAT_FULL_WIDTH = 'chat_full_width';

export class EntityStatuses {
  static readonly Active = 'Active';
  static readonly NotActive = 'NotActive';
}

export const LanguageCodes = {
  en: 'en-US',
  it: 'it-IT',
};

export const RGX_EMAIL_PATERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const USER_LOGOUT_LINK =
  'https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=http%3A%2F%2Flocalhost%2Fmyapp%2F';

export const DYNAMIC_FILTERS_NOT_SELECTED = 'notSelected';

export const AppBpmnModelerTabNames = {
  EventActions: 'eventActions',
  EventActionCustomers: 'eventActionCustomers',
  Info: 'info',
};

export const ROUTE_PATH_NEW = 'new';
export const ROUTE_PATH_OVERVIEW = 'overview';
export const ROUTE_PATH_PROPERTIES = 'properties';
export const APP_SIGN_IN_PENDING = 'APP_SIGN_IN_PENDING';

export const SharePointFolderTableStates = {
  Loading: 'loading',
  Table: 'table',
  Empty: 'empty',
  Error: 'error',
  Missing: 'missing',
} as const;

export type SharePointFolderTableState = (typeof SharePointFolderTableStates)[keyof typeof SharePointFolderTableStates];

export const SharePointFolderTableSelectionModes = {
  Single: 'single',
  Multiple: 'multiple',
} as const;

export type SharePointFolderTableSelectionMode =
  (typeof SharePointFolderTableSelectionModes)[keyof typeof SharePointFolderTableSelectionModes];

export namespace AppFilters {
  export const UsersFilterItems = {
    IDProfile: 'IDProfile',
  };

  export const ProfilePermissionsFilterItems = {
    ShortNames: 'ShortNames',
  };

  export const ClientCompaniesFilterItems = {
    AssignedPhoneNumber: 'AssignedPhoneNumber',
    IndustryType: 'IndustryType',
    BusinessSize: 'BusinessSize',
    ContractType: 'ContractType',
    ActiveStatus: 'ActiveStatus',
    SubscriptionPlan: 'SubscriptionPlan',
    SupportLevel: 'SupportLevel',
    CreatedAt: 'CreatedAt',
    CreatedBy: 'CreatedBy',
    UpdatedBy: 'UpdatedBy',
  };

  export const GroupsFilterItems = {
    CreatedAt: 'CreatedAt',
    CreatedBy: 'CreatedBy',
    UpdatedBy: 'UpdatedBy',
  };

  export const ProductsFilterItems = {
    CreatedAt: 'CreatedAt',
    CreatedBy: 'CreatedBy',
    UpdatedBy: 'UpdatedBy',
    InsuranceCompany: 'IdInsuranceCompany',
    Area: 'Area',
    Type: 'Type',
    Typology: 'Typology',
    State: 'State',
  };

  export const IndexesFilterItems = {
    Ids: 'Ids',
    Name: 'Name',
    CreatedAt: 'CreatedAt',
    CreatedBy: 'CreatedBy',
  };

  export const ProfilesFilterItems = {
    CreatedAt: 'CreatedAt',
    CreatedBy: 'CreatedBy',
    UpdatedBy: 'UpdatedBy',
  };

  export const KIEnginesFilterItems = {
    CreatedAt: 'CreatedAt',
    CreatedBy: 'CreatedBy',
  };

  export const TracerLogsFilterItems = {
    CreatedAt: 'CreatedAt',
  };

  export const PpbxSystemsFilterItems = {
    Type: 'Type',
    Protocol: 'Protocol',
    Status: 'Status',
    CreatedAt: 'CreatedAt',
    CreatedBy: 'CreatedBy',
    UpdatedBy: 'UpdatedBy',
  };

  export const InboundChannelsFilterItems = {
    Type: 'Type',
    Status: 'Status',
    Priority: 'Priority',
    RoutingStrategy: 'RoutingStrategy',
    CreatedAt: 'CreatedAt',
    CreatedBy: 'CreatedBy',
    UpdatedBy: 'UpdatedBy',
  };

  export const InboundCallsFilterItems = {
    AssignedCompany: 'AssignedCompany',
    VoipProvider: 'VoipProvider',
    ModelProvider: 'ModelProvider',
    CreatedAt: 'CreatedAt',
  };

  export const PhoneNumbersFilterItems = {
    AssignedCompany: 'AssignedCompany',
    CreatedAt: 'CreatedAt',
    CreatedBy: 'CreatedBy',
    UpdatedBy: 'UpdatedBy',
  };

  export const ChatFilters = {
    ProjectId: 'ProjectId'
  }
}

export namespace AppConstants {
  export const TEXTAREA_DEFAULT_MAX_LENGTH = 9999999;

  export const getWorkflowDefaultTranslations = () => [
    {
      lang: LanguageCodes.it,
      value: '',
    },
    {
      lang: LanguageCodes.en,
      value: '',
    },
  ];

  export const HttpFormCollectionKeys = {
    IdDocument: 'idDocument',
    IdWorkflowProcessState: 'idWorkflowProcessState',
    DocumentIdentifiers: 'documentIdentifiers',
    IdProduct: 'idProduct',
    ProductDocumentType: 'productDocumentType',
    IdProductDocumentDipa: 'idProductDocumentDipa',
  };

  export const PracticeDocumentStatuses = {
    NotIndexed: 'NotIndexed',
    IndexingOngoing: 'IndexingOngoing',
    IndexingCompleted: 'IndexingCompleted',
    IndexingFailed: 'IndexingFailed',
    GenerationDocOngoing: 'GenerationDocOngoing',
  };

  export const FileExtensions = {
    DOCX: 'docx',
    PDF: 'pdf',
    XLSX: 'xlsx',
    dotx: 'dotx',
    docm: 'docm',
    dotm: 'dotm',
    dot: 'dot',
    doc: 'doc',
    rtf: 'rtf',
    txt: 'txt',
    xml: 'xml',
    jpg: 'jpg',
    png: 'png',
    jpeg: 'jpeg',
    bmp: 'bmp',
    gif: 'gif',
    webp: 'webp',
    svg: 'svg',
    ico: 'ico',
    tiff: 'tiff',
  };

  export const SFDTDocumentExtensions = [
    FileExtensions.DOCX,
    FileExtensions.dotx,
    FileExtensions.docm,
    FileExtensions.dotm,
    FileExtensions.dot,
    FileExtensions.doc,
    FileExtensions.rtf,
    FileExtensions.txt,
    FileExtensions.xml,
  ];

  export const ImageExtensions = [
    FileExtensions.jpg,
    FileExtensions.png,
    FileExtensions.jpeg,
    FileExtensions.bmp,
    FileExtensions.gif,
    FileExtensions.webp,
    FileExtensions.svg,
    FileExtensions.ico,
    //FileExtensions.tiff
  ];

  export const MessageFeedback = {
    Positive: 'Pos',
    Negative: 'Neg',
    Unknown: 'Unk',
  };

  export const ChatGptRoles = {
    User: 'User',
    Assistant: 'Assistant',
  };

  export const DocumentFileStatuses = {
    NotIndexed: 'NotIndexed',
    IndexingOngoing: 'IndexingOngoing',
    IndexingCompleted: 'IndexingCompleted',
    IndexingFailed: 'IndexingFailed',
    GenerationDocOngoing: 'GenerationDocOngoing',
  };

  export const ProductDocumentType = {
    Dipa: 'Dipa',
    Attachment: 'Attachment',
    Simplification: 'Simplification',
  };

  export const DipaFileNames = {
    DIPA_PDF_NAME: 'DipA_Original.pdf',
    DIPA_DOCX_NAME: 'DipA_Original.docx',
    DIPA_ORIGINAL_MARKDOWN: 'DipA_Original.md',
    DIPA_SIMPLIFICATION_MARKDOWN: 'DipA_Sempl.md',
    DIPA_SIMPLIFICATION_PDF: 'DipA_Sempl.pdf',
    DIPA_SIMPLIFICATION_DOCX: 'DipA_Sempl.docx',
    DIPA_SIMPLIFICATION_JSON: 'DipA_Sempl.json',
  };

  export const ProfilePermissionsFilterValues = {
    All: 'All',
    Read: 'Read',
    Write: 'Write',
    Delete: 'Delete',
  };
}
